/**
 * Claves i18n de títulos del menú lateral (`menu.*` en es.json / en.json).
 * Exportadas para concordancia entre ROUTES, badges, templates y features (p. ej. Tickets).
 */
export const MENU_ITEM_TITLE_KEYS = {
  home: 'menu.home',
  operational: 'menu.operational',
  financial: 'menu.financial',
  security: 'menu.security',
  configurations: 'menu.configurations',
  myCommunity: 'menu.myCommunity',
  approveUsers: 'menu.approveUsers',
  ticketsPqrs: 'menu.ticketsPqrs',
  ticketsV2: 'menu.ticketsV2',
  aiAssistant: 'menu.aiAssistant',
  accountStatements: 'menu.accountStatements',
  transactions: 'menu.transactions',
  integrations: 'menu.integrations',
  pqrs: 'menu.pqrs',
  notices: 'menu.notices',
  chats: 'menu.chats',
  reservations: 'menu.reservations',
  visits: 'menu.visits',
  knowledgeCenter: 'menu.knowledgeCenter',
  toggle: 'menu.toggle',
} as const;

export type MenuItemTitleKey = (typeof MENU_ITEM_TITLE_KEYS)[keyof typeof MENU_ITEM_TITLE_KEYS];
